/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

export function registerAceEditor() {
    // ACE Less Editor
    let aceEditor = ace.edit($('.dd-less-editor')[0]);
    aceEditor.setTheme('ace/theme/xcode');
    aceEditor.getSession().setMode('ace/mode/less');

    let $cssModal = $('.dd-css-modal');
    $cssModal.modal({
        backdrop: false,
        keyboard: false,
        show: false
    }).on('show.bs.modal', function () {
        aceEditor.setValue($('#elm_edit_css').val());
    });

    $('.dd-css-form').on('submit', function (e) {
        e.preventDefault();
        $('#elm_edit_css').val(aceEditor.getValue());
        $cssModal.modal('hide');
    });

    $('.dd-veditor-css-action').on('click', function () {
        if (!$(this).hasClass('disabled')) {
            $cssModal.modal('show');
        }
    });
}

export function initAceEditor() {
    // Predefined CSS Classes
    if (typeof $().selectize == 'function') {
        let cssClassOptions = [];
        if (window.cssclasses && window.cssclasses.length) {
            for (let i in window.cssclasses) {
                cssClassOptions.push({
                    label: window.cssclasses[i],
                    value: window.cssclasses[i]
                })
            }
        }

        $('.dd-widget-class').selectize({
            delimiter: ' ',
            persist: false,
            maxItems: null,
            valueField: 'value',
            labelField: 'label',
            searchField: ['label'],
            options: cssClassOptions,
            create: function (input) {
                return {label: input, value: input}
            }
        });
    }
}
